// src/services/firmDetails.js
// Реквизиты фирмы для плейсхолдеров договоров, по проекту (currentProject).
export const FIRM_DETAILS = {
  ColorPartner: {
    companyName: 'COLOR PARTNER sp. z o.o.',
    nip: '8943198563',
    krs: '0001001466',
    address: 'ul. Grabiszyńska 214/7, 53-235 Wrocław',
    stampUrl: 'https://firebasestorage.googleapis.com/v0/b/ccmcolorpartner.appspot.com/o/images%2F1751601259392_%D0%9A%D0%BE%D0%BF%D0%B8%D1%8F%20piecza%CC%A8tka.jpeg?alt=media&token=c9f82822-77d9-4d84-ac7c-451c103229d8',
  },
  // TODO: реквизиты Spario — заполнит пользователь
  Spario: {
    companyName: '',
    nip: '',
    krs: '',
    address: '',
    stampUrl: '',
  },
};

// Готовы ли данные фирмы для генерации договоров
export const hasFirmDetails = (firm) => !!(firm && firm.companyName && firm.nip);
